// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shell for /monitor. The .pageShell rules are copied verbatim from
   CatalogMasterPage.module.css, comments included, because the constraint they
   encode is the same one. */

.BNunv4Wyt9HrRd8edSj5 {
  /* Bounded height, not min-height: html/body never scroll (overflow:hidden in
     MainCanvas.css, injected app-wide), so each region must own its scroll
     within the viewport or overflowing content is simply unreachable (#161). */
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: var(--curio-font-family);
  background: var(--curio-page-bg);
  color: var(--curio-text-primary);
  /* Reserve the bottom-right corner for the fixed VersionBadge (#236).
     Bounded height means border-box is load-bearing: the padding has to come
     out of the 100vh, not add to it. */
  box-sizing: border-box;
  padding-bottom: var(--curio-version-badge-reserve);
}

/* Unlike /catalog and /projects, this page's own content scrolls rather than a
   nested drawer, so the scroll region is here instead of inside a child. */
.O5qtRjgwrvGxdrc7PJFr {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px 32px;
}

/* ── Public header (no signed-in user) ───────────────────────────────── */

.Esq4WMjOCu6Ei2EQZf79 {
  height: 65px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--curio-top-bar-bg);
  border-bottom: 1px solid var(--curio-top-bar-border);
}

.uc5n59oX8kbtYxloHm_H {
  display: contents;
}

.cB6yYbQTW4NZmwaC11XF {
  max-height: 100%;
  width: auto;
  margin-left: 15px;
}

.AbdMhQae5PFubWlN1ygE {
  color: var(--curio-text-on-dark);
  font-size: 14px;
  font-weight: 600;
}

/* ── Toolbar ─────────────────────────────────────────────────────────── */

.SmSLCAvc1gstWrIAyUwM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.kVUgnTeEQGGGiaUEVpVQ {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.jDH8uFDadfK078O9YeVp {
  display: flex;
  gap: 8px;
}

.mLVZsbzGSYlfa4OAvjTV {
  font-size: 12px;
  color: var(--curio-text-secondary);
  font-variant-numeric: tabular-nums;
}

.ReJGsRMmUAoAltbb_USt {
  font-size: 12px;
  padding: 3px 9px;
  border-radius: var(--curio-radius-pill);
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}

.QPDk19GU0s5zNbCmpYPE {
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 12px;
  border-radius: var(--curio-radius-md);
  border: 1px solid var(--curio-border-strong);
  background: #fff;
  color: var(--curio-text-primary);
}

.QPDk19GU0s5zNbCmpYPE:hover {
  background: var(--curio-surface-muted);
}

/* ── Sections ────────────────────────────────────────────────────────── */

.My3HsGvO2A00Ag50Wrr4 {
  margin-bottom: 26px;
}

.e4GBGd7aB85gckgwEvaj {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--curio-text-secondary);
}

.qaEvnxnBKVV8mUsOjyNk {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--curio-text-secondary);
}

._0psjTodHZd39Ml2gMfNw {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 12px;
}

.bqsqR463wABxb2i3R8XT {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0 24px;
  background: #fff;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-card);
  padding: 4px 16px;
}

._OXfUzigMQp05hw1AcFQ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.VqQqF1vfqtS8R9tZneeg {
  background: #fff;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-card);
  padding: 14px 16px;
  min-width: 0;
}

.fQL_IWIPaiVKv4SWSmBc {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.fQL_IWIPaiVKv4SWSmBc td {
  padding: 5px 0;
  border-bottom: 1px solid var(--curio-border);
  color: var(--curio-text-primary);
}

.fQL_IWIPaiVKv4SWSmBc tr:last-child td {
  border-bottom: none;
}

.NfW3fZL5nsofqkPrrXre {
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: var(--curio-text-secondary);
  white-space: nowrap;
}

.KJUyhtYkTnzwiOZqRdxA {
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--curio-text-secondary);
}

._7oEr2JYBl0TEaOEgGRKe {
  margin: 0;
  padding: 10px 0;
  font-size: 13px;
  color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/monitor/MonitorPage.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;EACE;;+EAE6E;EAC7E,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC;;uCAEqC;EACrC,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;2EAC2E;AAC3E;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2EAA2E;;AAE3E;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,2EAA2E;;AAE3E;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC","sourcesContent":["/* Shell for /monitor. The .pageShell rules are copied verbatim from\n   CatalogMasterPage.module.css, comments included, because the constraint they\n   encode is the same one. */\n\n.pageShell {\n  /* Bounded height, not min-height: html/body never scroll (overflow:hidden in\n     MainCanvas.css, injected app-wide), so each region must own its scroll\n     within the viewport or overflowing content is simply unreachable (#161). */\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: var(--curio-font-family);\n  background: var(--curio-page-bg);\n  color: var(--curio-text-primary);\n  /* Reserve the bottom-right corner for the fixed VersionBadge (#236).\n     Bounded height means border-box is load-bearing: the padding has to come\n     out of the 100vh, not add to it. */\n  box-sizing: border-box;\n  padding-bottom: var(--curio-version-badge-reserve);\n}\n\n/* Unlike /catalog and /projects, this page's own content scrolls rather than a\n   nested drawer, so the scroll region is here instead of inside a child. */\n.scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px 32px;\n}\n\n/* ── Public header (no signed-in user) ───────────────────────────────── */\n\n.publicBar {\n  height: 65px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--curio-top-bar-bg);\n  border-bottom: 1px solid var(--curio-top-bar-border);\n}\n\n.publicBarLink {\n  display: contents;\n}\n\n.publicBarLogo {\n  max-height: 100%;\n  width: auto;\n  margin-left: 15px;\n}\n\n.publicBarTitle {\n  color: var(--curio-text-on-dark);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* ── Toolbar ─────────────────────────────────────────────────────────── */\n\n.toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.toolbarStatus {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.toolbarActions {\n  display: flex;\n  gap: 8px;\n}\n\n.updated {\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n.staleBanner {\n  font-size: 12px;\n  padding: 3px 9px;\n  border-radius: var(--curio-radius-pill);\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n\n.button {\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 5px 12px;\n  border-radius: var(--curio-radius-md);\n  border: 1px solid var(--curio-border-strong);\n  background: #fff;\n  color: var(--curio-text-primary);\n}\n\n.button:hover {\n  background: var(--curio-surface-muted);\n}\n\n/* ── Sections ────────────────────────────────────────────────────────── */\n\n.section {\n  margin-bottom: 26px;\n}\n\n.heading {\n  margin: 0 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--curio-text-secondary);\n}\n\n.subHeading {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.tileGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 12px;\n}\n\n.chipGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 0 24px;\n  background: #fff;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-card);\n  padding: 4px 16px;\n}\n\n.split {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.card {\n  background: #fff;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-card);\n  padding: 14px 16px;\n  min-width: 0;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.table td {\n  padding: 5px 0;\n  border-bottom: 1px solid var(--curio-border);\n  color: var(--curio-text-primary);\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  color: var(--curio-text-secondary);\n  white-space: nowrap;\n}\n\n.caption {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n}\n\n.empty {\n  margin: 0;\n  padding: 10px 0;\n  font-size: 13px;\n  color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageShell": `BNunv4Wyt9HrRd8edSj5`,
	"scroll": `O5qtRjgwrvGxdrc7PJFr`,
	"publicBar": `Esq4WMjOCu6Ei2EQZf79`,
	"publicBarLink": `uc5n59oX8kbtYxloHm_H`,
	"publicBarLogo": `cB6yYbQTW4NZmwaC11XF`,
	"publicBarTitle": `AbdMhQae5PFubWlN1ygE`,
	"toolbar": `SmSLCAvc1gstWrIAyUwM`,
	"toolbarStatus": `kVUgnTeEQGGGiaUEVpVQ`,
	"toolbarActions": `jDH8uFDadfK078O9YeVp`,
	"updated": `mLVZsbzGSYlfa4OAvjTV`,
	"staleBanner": `ReJGsRMmUAoAltbb_USt`,
	"button": `QPDk19GU0s5zNbCmpYPE`,
	"section": `My3HsGvO2A00Ag50Wrr4`,
	"heading": `e4GBGd7aB85gckgwEvaj`,
	"subHeading": `qaEvnxnBKVV8mUsOjyNk`,
	"tileGrid": `_0psjTodHZd39Ml2gMfNw`,
	"chipGrid": `bqsqR463wABxb2i3R8XT`,
	"split": `_OXfUzigMQp05hw1AcFQ`,
	"card": `VqQqF1vfqtS8R9tZneeg`,
	"table": `fQL_IWIPaiVKv4SWSmBc`,
	"num": `NfW3fZL5nsofqkPrrXre`,
	"caption": `KJUyhtYkTnzwiOZqRdxA`,
	"empty": `_7oEr2JYBl0TEaOEgGRKe`
};
export default ___CSS_LOADER_EXPORT___;
